import { Box } from "@mui/material";
import { useTheme } from "@mui/material";

import { colors } from "@/Utils";

interface HorizontalScrollProps {
  children: React.ReactNode;
  minWidth: number;
}

export const HorizontalScroll: React.FC<HorizontalScrollProps> = ({ children, minWidth }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        overflowX: "auto",
        paddingBottom: "0.5rem",
        // Webkit scrollbar styles
        "&::-webkit-scrollbar": {
          height: "9px",
          cursor: "pointer",
        },
        "&::-webkit-scrollbar-track": {
          WebkitBoxShadow:
            theme.palette.mode === "light"
              ? "inset 0 0 30px #f4f4f4"
              : `inset 0 0 30px ${colors.lightBlack}`,
          borderRadius: "3px",
        },
        "&::-webkit-scrollbar-thumb": {
          borderRadius: "3px",
          width: "5px",
          height: "5px",
          WebkitBoxShadow: `inset 30 0 0px ${colors.bodyMain}`,
          background: theme.palette.mode === "light" ? colors.darkWhite : colors.SelectBg,
          cursor: "pointer",
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          minWidth: `${minWidth}px`,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default HorizontalScroll;
